import { Component, Inject } from '@angular/core';
import { DialogService, DialogRef, DialogConfig, DIALOG_DATA } from '../dialog';

export interface StatefulLoadingDialogData {
  title: string;
  content: string;
  noSpinner?: boolean;
  action?: {
    label: string;
  };
}

@Component({
  selector: 'app-stateful-loading',
  templateUrl: './stateful-loading.component.html',
  styleUrls: ['./stateful-loading.component.scss'],
})
export class StatefulLoadingComponent {
  constructor(
    public dialogRef: DialogRef<StatefulLoadingComponent, boolean>,
    @Inject(DIALOG_DATA) public data: StatefulLoadingDialogData
  ) {}

  public static open(
    dialog: DialogService,
    data: StatefulLoadingDialogData,
    config?: DialogConfig
  ): DialogRef<StatefulLoadingComponent, boolean> {
    const c: DialogConfig = config || {};
    c.panelClass = 'simple-dialog';
    c.maxWidth = 'calc(100vw - 32px)';
    c.data = data;
    return dialog.open(StatefulLoadingComponent, c);
  }

  actionClicked() {
    this.dialogRef.close(false);
  }
}
